import { UserStatus } from '@freelancer/datastore/project-view-users';
import { EnterpriseApi } from 'api-typings/common/common';
import { UserApi, UserStatusApi } from 'api-typings/users/users';
import { User } from './users.model';

export function transformUser(user: UserApi): User {
  if (
    !user.id ||
    !user.username ||
    !user.avatar_cdn ||
    !user.avatar_large_cdn ||
    !user.role
  ) {
    throw new ReferenceError(`Missing a required user field.`);
  }

  const displayName: string =
    user.support_status && user.support_status.short_name
      ? user.support_status.short_name
      : user.public_name || user.display_name || user.username;
  const onlineOfflineStatus = user.online_offline_status
    ? {
        status: user.online_offline_status.status,
        lastUpdatedTimestamp: user.online_offline_status.last_updated_timestamp
          ? user.online_offline_status.last_updated_timestamp * 1000
          : undefined,
      }
    : undefined;
  return {
    id: user.id,
    avatar: transformUserImage(user.avatar_cdn),
    avatarLarge: transformUserImage(user.avatar_large_cdn),
    supportStatus: user.support_status
      ? {
          type: user.support_status.type,
          shortName: user.support_status.short_name,
        }
      : undefined,
    username: user.username,
    closed: user.closed || false,
    displayName,
    role: user.role,
    chosenRole: user.chosen_role,
    profileUrl: `/u/${user.username}`,
    onlineOfflineStatus,
    currency: user.primary_currency,
    status: user.status ? transformUserStatus(user.status) : user.status,
    enterpriseIds: user.enterprise_ids,
    isDeloitteDcUser:
      user.enterprise_ids &&
      user.enterprise_ids.includes(EnterpriseApi.DELOITTE_DC),
    poolIds: user.pool_ids,
    escrowComInteractionRequired: !!user.escrowcom_interaction_required,
  };
}

export function transformUserStatus(status: UserStatusApi): UserStatus {
  return {
    paymentVerified: status.payment_verified || false,
    emailVerified: status.email_verified || false,
    depositMade: status.deposit_made || false,
    profileComplete: status.profile_complete || false,
    phoneVerified: status.phone_verified || false,
    identityVerified: status.identity_verified || false,
    facebookConnected: status.facebook_connected || false,
  };
}

export function transformUserImage(image: string): string | undefined {
  return !image.endsWith('/img/unknown.png') ? image : undefined;
}
